"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseAPIClient = void 0;
const isNil_1 = __importDefault(require("lodash/isNil"));
const axios_1 = __importDefault(require("axios"));
const AppError_1 = require("./AppError");
class BaseAPIClient {
    static prepareRequestHeaders(headers) {
        return Object.assign({}, headers);
    }
    static prepareRequestParams(params) {
        return params;
    }
    static prepareResponse(request, result) {
        console.assert(request);
        const response = {
            request,
            date: new Date(),
            success: true,
            canceled: false,
            status: 0,
            statusText: '',
        };
        if ((0, isNil_1.default)(result))
            return response;
        const httpResponse = result;
        response.success = httpResponse.status >= 200 && httpResponse.status < 300;
        if (result instanceof Error) {
            const error = result;
            let errorCode = -1;
            let errorMessage = error.message;
            const errorResponse = error.response;
            if (errorResponse) {
                if (!(0, isNil_1.default)(errorResponse.status))
                    errorCode = errorResponse.status;
                if (!(0, isNil_1.default)(errorResponse.statusText))
                    errorMessage = errorResponse.statusText;
            }
            response.success = false;
            response.canceled = axios_1.default.isCancel(error);
            response.status = errorCode;
            response.statusText = errorMessage;
            if (!response.success) {
                response.error = new AppError_1.AppError(error);
                response.error.code = errorCode;
            }
        }
        else {
            const apiResponse = result;
            response.canceled = apiResponse.canceled;
            response.status = apiResponse.status;
            response.statusText = apiResponse.statusText;
            if (!response.success && httpResponse.data.error) {
                response.error = httpResponse.data.error;
            }
        }
        return response;
    }
}
exports.BaseAPIClient = BaseAPIClient;
_a = BaseAPIClient;
BaseAPIClient.interceptors = {
    request: {},
    response: {},
};
BaseAPIClient.createClient = (options, extraConfig) => {
    var _b, _c;
    const result = {};
    const clientConfig = Object.assign({}, extraConfig);
    result.client = axios_1.default.create(clientConfig);
    // Bubble up all 4XX status codes for UI to catch / handle.
    result.client.interceptors.response.use(undefined, (error) => {
        if (error.response && error.response.status < 500 && error.response.status >= 400) {
            return Promise.resolve(error.response);
        }
        else
            return Promise.reject(error);
    });
    if (!(0, isNil_1.default)(BaseAPIClient.interceptors.request.onFulfilled) ||
        !(0, isNil_1.default)(BaseAPIClient.interceptors.request.onRejected)) {
        result.client.interceptors.request.use(BaseAPIClient.interceptors.request.onFulfilled, BaseAPIClient.interceptors.request.onRejected);
    }
    if (!(0, isNil_1.default)(BaseAPIClient.interceptors.response.onFulfilled) ||
        !(0, isNil_1.default)(BaseAPIClient.interceptors.response.onRejected)) {
        result.client.interceptors.response.use(BaseAPIClient.interceptors.response.onFulfilled, BaseAPIClient.interceptors.response.onRejected);
    }
    const cancelTokenHelper = axios_1.default.CancelToken;
    result.cancelToken = cancelTokenHelper.source();
    const config = {};
    config.headers = _a.prepareRequestHeaders((_b = clientConfig.headers) !== null && _b !== void 0 ? _b : {});
    config.params = _a.prepareRequestParams({});
    config.cancelToken = result.cancelToken.token;
    config.withCredentials = (_c = clientConfig.withCredentials) !== null && _c !== void 0 ? _c : true;
    result.config = config;
    return result;
};
